import React, { useState } from 'react';
import Draggable, { DraggableSlider } from '../../wrappers/draggable';
import { CardButtons } from '../../fragments/card-gallery';

const Testimonials = ({ block }) => {
  const [active, setActive] = useState(0);
  const { type, testimonials } = block;

  const slideLeft = () => {
    const newActive = active - 1 < 0 ? testimonials.length - 1 : active - 1;
    setActive(newActive);
  };

  const slideRight = () => {
    const newActive = (active + 1) % testimonials.length;
    setActive(newActive);
  };

  const toggleIndicator = ({ target }) => {
    const dataIndex = target.getAttribute('data-index');
    const index = parseInt(dataIndex, 10);
    if (index !== active) {
      setActive(index);
    }
  };

  let blockType = type ? `block__testimonials--${type}` : '';

  if (testimonials.length > 1) {
    return (
      <section
        className={`block ${block._template} ${block.css_class_name} ${blockType}`}
      >
        <div className='container'>
          <CardButtons
            slideLeft={slideRight}
            slideRight={slideLeft}
            state='large'
          />
          <Draggable
            triggerOnLeftDrag={slideRight}
            triggerOnRightDrag={slideLeft}
            active={active}
            wrapperClassName='testimonials-wr'
            items={testimonials}
            template={Testimonial}
            additionalProps={{ active, show_index: block.show_index }}
            gap={140} // value when item card is not cut anymore
          />
          <section className='slider--centered slider--mt-sm'>
            <DraggableSlider
              itemsCount={testimonials.length}
              triggerOnClick={toggleIndicator}
              activeIndex={active}
              state={'dark'}
            />
          </section>
        </div>
      </section>
    );
  }

  return (
    <section
      className={`block ${block._template} ${block.css_class_name} ${blockType}`}
    >
      <div className='container'>
        {testimonials.map((testimonial, index) => {
          return (
            <Testimonial
              key={index}
              item={testimonial}
              className='row'
            />
          );
        })}
      </div>
    </section>
  );
};

const Testimonial = ({ item, className, index, active, style }) => {
  const activeClass = active === index ? 'is-active' : '';
  return (
    <div
      className={className ? className : `testimonial ${activeClass}`}
      style={style}
    >
      <div className='image col-lg-4 col-md-12 offset-md-0 offset-1 col-10'>
        {item.image && (
          <img
            src={item.image}
            className='testimonials__image'
            alt={item.image_alt_text}
            title={item.image_alt_text}
          />
        )}
      </div>
      <div className='col-lg-8 col-md-12 offset-md-0 offset-1 col-10'>
        <div className='content-wr content-wr--quoted'>
          {item.quote && (
            <h3
              className='testimonials__quote'
              dangerouslySetInnerHTML={{ __html: item.quote }}
            ></h3>
          )}
          {item.name && <h4 className='testimonials__name'>{item.name}</h4>}
          {item.company && (
            <p className='testimonials__company'>{item.company}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
